// extracted by mini-css-extract-plugin
export default {"wrapper":"jpKtD7","change-colors":"eM96ht","changeColors":"eM96ht","text":"ijocSb"};